import { render, staticRenderFns } from "./set-live-time.vue?vue&type=template&id=49216654&scoped=true&"
import script from "./set-live-time.vue?vue&type=script&lang=js&"
export * from "./set-live-time.vue?vue&type=script&lang=js&"
import style0 from "./set-live-time.vue?vue&type=style&index=0&id=49216654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49216654",
  null
  
)

export default component.exports